export const isOverflowing = (element) => {
  if (!element) return false;
  return element.scrollWidth > element.clientWidth;
};